module.exports = __webpack_public_path__ + "static/media/ca_11.a5140566.png";